import gql from 'graphql-tag'

// Custom `calculateSigns` schema extension
export const calculateSigns = gql`
	mutation($birthDate: Json!, $birthTime: Json!) {
		calculateSigns(
			birthDate: $birthDate
			birthTime: $birthTime
		) {
			birthSigns
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/signs.js